module.exports = __webpack_public_path__ + "static/media/b.20def7bf.jpg";